import React, { useMemo, useState } from 'react';
import Table from '../../../components/Tables/Schedule';
import { headerMaker } from '../../../components/Tables/Schedule/helper';
import Spinner from '../../../components/Spinner';
import { usePaginate } from 'hooks/usePaginate';
import { schedulesHeader } from 'redux/modules/table/common';
import {
  Wrapper,
  Title,
  FilterContainer,
  Label,
  FilterItem,
  PageHeader,
} from './style';
import Select from 'components/FormElements/Select';
import DatePicker from 'components/DatePicker';
import { Button } from 'antd';
import { useSelector } from 'react-redux';
import { timeOptions } from './helper';
import service from '../../../services/reports';
import DownloadToExcell from 'components/DownloadToExcell';
import { timeFormatter } from 'utils/timeFormatter';

export default () => {
  const { data, handleOnTableChange, pageCount } = usePaginate();
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [postData, setPostData] = useState({});
  const [subCategories, setSubCategories] = useState([]);
  const { categories, groups } = useSelector((state) => state.appReducer);
  const { singleDate } = useSelector((state) => state.selectedDateReducer);
  const headers = useMemo(
    () => headerMaker(schedulesHeader),
    [schedulesHeader]
  );

  const fetchReport = async () => {
    try {
      setLoading(true);
      const payload = {
        date: `${singleDate} ${postData.time}`,
        category: postData.category,
        subCategory: postData.subCategory,
        group: postData.group,
      };
      const resp = await service.getUserReportBySchedule(payload);
      const result = resp.map((item) => ({
        user_name: `${item.user.lastName} ${item.user.firstName} ${item.user.middleName}`,
        region: item?.user?.region?.title,
        object: item?.user?.object?.title,
        comingTime: item?.comingDate,
        came: {
          value: item?.comingDate ? 'Келди' : '-',
          bg: item?.comingDate ? '#e3f0ff' : 'transparent',
          color: '#3380ff',
          border: item?.comingDate ? '1px solid #a0aec033' : 'none',
        },
        lateTime: {
          value: timeFormatter(item?.lateTime),
          minute: item?.lateTime,
          bg: 'transparent',
          color: '#f00',
        },
      }));
      setReportData(result);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleSelectCategory = (value) => {
    const subCategoryData = categories.filter((item) => item.parent === value);
    setSubCategories(subCategoryData);
  };

  if (loading) return <Spinner maxHeight='100%' />;
  return (
    <Wrapper>
      <PageHeader>
        <Title>Рўйхат</Title>
        <DownloadToExcell
          fileName={'Меҳнат интизоми'}
          tableName={'Меҳнат интизоми'}
          tableHeader={headers}
          tableData={reportData}
        />
      </PageHeader>
      <FilterContainer>
        <FilterItem>
          <Select
            handleChange={(value) => {
              setPostData({ ...postData, ['group']: value });
            }}
            name='group'
            options={groups}
            defaultVal={postData?.group}
            title='Гуруҳ'
          />
        </FilterItem>
        <FilterItem>
          <Select
            handleChange={(value) => {
              setPostData({
                ...postData,
                ['category']: value,
                ['subCategory']: '',
              });
              handleSelectCategory(value);
            }}
            options={categories?.filter((c) => c.parent === null)}
            name='category'
            title='Асосий категориялар'
            defaultVal={postData?.category}
          />
        </FilterItem>
        <FilterItem>
          <Select
            handleChange={(value) => {
              setPostData({ ...postData, ['subCategory']: value });
            }}
            options={subCategories}
            name='subCategory'
            title='Суб категориялар'
            defaultVal={postData?.subCategory}
          />
        </FilterItem>
        <FilterItem>
          <Label>Сана ва вақтни танланг</Label>
          <div className='schedule-picker'>
            <DatePicker withTitle={false} />
            <div className='custom-time-select-container'>
              <Select
                handleChange={(value) => {
                  setPostData({ ...postData, ['time']: value });
                }}
                options={timeOptions}
                name='time'
                defaultVal={postData?.time}
              />
            </div>
          </div>
        </FilterItem>
        <FilterItem>
          <Button
            type='primary'
            disabled={
              !postData.category ||
              !postData.subCategory ||
              !postData.group ||
              !singleDate ||
              !postData.time
            }
            onClick={fetchReport}
            style={{
              height: '40px',
              background: '#3380FF',
              borderRadius: '10px',
              padding: '0 20px',
            }}
          >
            Қидириш
          </Button>
        </FilterItem>
      </FilterContainer>
      <Table
        headers={headers}
        data={data}
        onChange={handleOnTableChange}
        page={pageCount}
        reportsData={reportData}
        total={reportData.length}
      />
    </Wrapper>
  );
};
